module.exports = __webpack_public_path__ + "b8d0f50be780482078e34330d42df53c.svg";